import Modal from '@/mixins/modal'
import OrderReturnDetailModal from '@/views/main/order/partials/OrderReturnDetailModal.vue'
import FeedbackModal from '@/views/main/operate/partials/FeedbackModal.vue'
import FeedbackRespModal from '@/views/main/operate/partials/FeedbackRespModal.vue'
import PasswordModifyModal from '@/views/main/partials/PasswordModifyModal.vue'
import OrderDeliveryDetailModal from '@/views/main/order/partials/OrderDeliveryDetailModal.vue'
import OrderPackageDetailModal from '@/views/main/order/partials/OrderPackageDetailModal.vue'
import ServiceOrderNowModal from '@/views/main/customer/partials/ServiceOrderNowModal.vue'
import PassportModal from '@/views/main/customer/partials/PassportModal.vue'
import ServiceOrderHistoryModal from '@/views/main/customer/partials/ServiceOrderHistoryModal.vue'
import ApproveModal from '@/views/main/customer/partials/ApproveModal.vue'
import PartOrderStatisticModal from '@/views/main/customer/partials/PartOrderStatisticModal.vue'
import QueryLogModal from '@/views/main/customer/partials/QueryLogModal.vue'
import ZoomModal from '@/views/main/home/partials/ZoomModal.vue'
import ReverseOrderApplyModal from '@/views/main/order/partials/ReverseOrderApplyModal'
import AddressEditModal from '@/views/main/order/partials/AddressEditModal'
import ApplyContextDetailModal from '@/views/main/order/partials/ApplyContextDetailModal'
import OrderQrCodeModal from '@/views/main/order/partials/OrderQrCodeModal'
import OfficalInfoModal from '@/views/main/order/partials/OfficalInfoModal'
import SetMonthTaskModal from '@/views/main/dashboard/partials/SetMonthTaskModal.vue'
import SetMonthMetrixModal from '@/views/main/dashboard/partials/SetMonthMetrixModal.vue'
import SetSeasonMetrixModal from '@/views/main/dashboard/partials/SetSeasonMetrixModal.vue'
import AccessLogModal from '@/views/main/customer/partials/AccessLogModal.vue'
import StartApproval from '@/views/main/order/partials/StartApproval.vue'
import RelPackageModal from '@/views/main/finance/RelPackageModal.vue'
import InvoiceDetailModal from '@/views/main/finance/InvoiceDetailModal.vue'
import PassportUnlockModal from '@/views/main/system/parts/PassportUnlockModal.vue'
import SplitOrderModal from '@/views/main/system/parts/SplitOrderModal.vue'
import EpcOrderPayModal from '@/views/main/system/parts/EpcOrderPayModal.vue'
import ItemSourceDetailModal from '@/views/main/order/partials/ItemSourceDetailModal.vue'

const modals = {
  ItemSourceDetailModal,
  EpcOrderPayModal,
  SplitOrderModal,
  PassportUnlockModal,
  SetSeasonMetrixModal,
  InvoiceDetailModal,
  RelPackageModal,
  AccessLogModal,
  SetMonthTaskModal,
  OrderReturnDetailModal,
  FeedbackModal,
  PasswordModifyModal,
  OrderDeliveryDetailModal,
  OrderPackageDetailModal,
  ServiceOrderNowModal,
  PassportModal,
  ServiceOrderHistoryModal,
  ApproveModal,
  PartOrderStatisticModal,
  FeedbackRespModal,
  QueryLogModal,
  ZoomModal,
  ReverseOrderApplyModal,
  AddressEditModal,
  ApplyContextDetailModal,
  OrderQrCodeModal,
  OfficalInfoModal,
  SetMonthMetrixModal,
  StartApproval
}

for (const key in modals) {
  // eslint-disable-next-line no-prototype-builtins
  if (modals.hasOwnProperty(key)) {
    Modal.registerModal(key, modals[key])
  }
}
